export function useIconLink() {
  function IconLink(icon) {
    function randomTilt(min, max) {
      let deg = 0;

      while (deg < min) {
        deg = Math.ceil(Math.random() * max);
      }
      const neg = Math.round(Math.random());
      if (neg === 0) {
        deg = deg * -1;
      }
      return `${deg}deg`;
    }

    icon.setAttribute("style", `--tilt: ${randomTilt(10, 20)};`);
  }

  const iconLinks = document.querySelectorAll(".icon-links__item");

  iconLinks.forEach((icon) => IconLink(icon));
}
